import React, { useState } from 'react';

const OtpInput = ({ label_name, name, value, onChange, onBlur, error }) => {
  const [otpArray, setOtpArray] = useState(Array(6).fill(''));

  const handleChange = (e, index) => {
    const val = e.target.value;

    // Allow only digits
    if (val && !/^\d+$/.test(val)) return;

    const newOtp = [...otpArray];
    newOtp[index] = val.slice(0, 1);
    setOtpArray(newOtp);

    // Update parent form value
    onChange(newOtp.join(''));

    // Move to next box automatically
    if (val && index < otpArray.length - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otpArray[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').trim();

    // Paste full 6-digit OTP
    if (/^\d{6}$/.test(pastedData)) {
      const newOtp = pastedData.split('');
      setOtpArray(newOtp);
      onChange(pastedData);
      document.getElementById(`otp-${otpArray.length - 1}`)?.focus();
    }
  };

  return (
    <div className="form-group mb-3 text-center">
      {label_name && <label className="form_label d-block mb-2">{label_name}</label>}
      <div className="d-flex justify-content-center gap-2">
        {otpArray.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            className="form-control otp-input text-center"
            style={{
              width: '50px',
              height: '50px',
              fontSize: '20px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              transition: '0.2s',
            }}
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={index === 0 ? handlePaste : null}
            autoFocus={index === 0}
            onBlur={onBlur}
          />
        ))}
      </div>
      {error && <small className="text-danger d-block mt-2">{error}</small>}
    </div>
  );
};

export default OtpInput;
